import React from 'react';
import withDashboardMenuLayout from '../../fibe-ui/layout/withDashboardMenuLayout';
import KeepYourSmartRepayInformativeScreen from '../../components/nach-cancellation/screens/keep-your-smart-repay-informative-screen';
import ReasonForMandateCancellation from '../../components/nach-cancellation/screens/reason-for-mandate-cancellation';
import AckScreen from '../../components/nach-cancellation/screens/ack-screen';
import getNachStatusAPICall from '../../components/nach-cancellation/helpers/get-nach-status';
import NachCancellationParent from '../../components/nach-cancellation/nach-cancellation-parent';
import { NC_MANDATE_LIST } from '../../components/nach-cancellation/screens/nc-screen-names';

const NachCancellationMandateListPage = () => {
  return withDashboardMenuLayout({
    currentRoute: '/nach-cancellation',
    childComponent: (
      <>
        {/* <KeepYourSmartRepayInformativeScreen /> */}
        {/* <ReceivedTheNachCancellationRequest /> */}
        {/* <ReasonForMandateCancellation /> */}
        {/* <AckScreen /> */}
        <NachCancellationParent screenToShow={NC_MANDATE_LIST} />
      </>
    ),
    isLeftProgressBarPresent: false,
  });
};

export default NachCancellationMandateListPage;
